import * as yup from "yup";
import { date, object, string } from "yup";

export const FolderSchema = object({
  id: string().required(),
  name: string().required(),
  organizationId: string().required(),
  createdAt: date().required(),
  updatedAt: date().required(),
  parentFolderId: string()
    .nullable()
    .transform((value) => value ?? null)
    .default(null),
  createdBy: string()
    .nullable()
    .transform((value) => value ?? null)
    .default(null),
});

export interface Folder extends yup.InferType<typeof FolderSchema> {}
